import CryptoJS from "crypto-js";
import Cookies from "js-cookie";

const aesKey = Cookies.get("aes_key");

function decrypt(input) {
  const keyHash = CryptoJS.SHA384(process.env.REACT_APP_AES_KEY);
  const key = CryptoJS.enc.Hex.parse(keyHash.toString().substring(0, 64));
  const iv = CryptoJS.enc.Hex.parse(keyHash.toString().substring(64, 96));
  const decrypt = CryptoJS.AES.decrypt(input, key, { iv: iv });
  const decryptStr = decrypt.toString(CryptoJS.enc.Utf8);
  return decryptStr.toString();
}

function wm_aes_decrypt_for_web(input, aesKeyForWeb) {
  const keyHash = CryptoJS.SHA384(aesKeyForWeb);
  const key = CryptoJS.enc.Hex.parse(keyHash.toString().substring(0, 64));
  const iv = CryptoJS.enc.Hex.parse(keyHash.toString().substring(64, 96));
  const decrypt = CryptoJS.AES.decrypt(input, key, { iv: iv });
  const decryptStr = decrypt.toString(CryptoJS.enc.Utf8);
  return decryptStr.toString();
}

export { decrypt, wm_aes_decrypt_for_web };
